<form name="form" class="page-fix-accessibility-form" #form="ngForm">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoViewType"
                                 [monSelected]="!pageFix"
                                 [monOrder]="0">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/website-structure/new-window.png"
                     [attr.alt]="'New Window Information' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Why can't I open a new window without warning?</h2>
                <p translate>
                    A link opening a new window or tab automatically and without a warning can be confusing for people having trouble perceiving visual content.
                    Actually warning the users beforehand gives them an opportunity to evaluate if they want to leave the current page and help them understand that they are now operating in a new window/tab and can't click the "back" button to return to the previous view.
                </p>
                <h3 translate>And how are we going to fix it?</h3>
                <p translate>
                    For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-new-window-options [monPageFix]="pageFix"
                                          [monPageFixId]="pageFixId"
                                          [monPageFixSelector]="pageFixSelector"
                                          [monType]="optionsViewType"
                                          [monSelected]="!!pageFix"
                                          [monOrder]="1">
        </page-fix-form-new-window-options>
        <page-fix-form-info-view [monType]="testingViewType" [monOrder]="2">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/website-structure/new-window-test.png"
                     [attr.alt]="'New Window Test' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Trying out the pop-up</h2>
                <p translate>
                    Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
